import React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";

import WidgetTotalValueSwitcher, { WidgetTotalValueSwitcherProps } from "./WidgetTotalValueSwitcher";

export interface WidgetInnerHeaderProps extends Partial<WidgetTotalValueSwitcherProps> {
  containerWidth?: number;
  title: string;
}

export const WidgetInnerHeader: React.FunctionComponent<WidgetInnerHeaderProps> = ({
  title, containerWidth, graphDataType, updateGraphDataType, ...rest
}) => {
  return (
    <StyledWrapper isSmallContainer={!!(containerWidth && containerWidth < 300)}>
      <Text as="h3">
        {title}
      </Text>

      {graphDataType && updateGraphDataType && (
        <WidgetTotalValueSwitcher
          graphDataType={graphDataType}
          updateGraphDataType={updateGraphDataType}
          {...rest}
        />
      )}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div<{isSmallContainer: boolean}>`
  ${({ theme, isSmallContainer }) => css`
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: ${theme.spacing.padding.sm};

    h3 {
      margin-bottom: ${theme.spacing.margins.xs};
    }

    ${!isSmallContainer && `
      position: relative;
      justify-content: flex-end;
      align-items: center;
    
      h3 {
        flex: 0 1 auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
  
      .widget-total-value-switcher {
        flex: 0 1 auto;
        margin-left: auto;
      }
    `}
  `}
`;
